import { Moon } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

export const SleepStory = ({ onClose }) => (
  <Dialog onOpenChange={(open) => !open && onClose()}>
    <DialogTrigger asChild>
      <button className="story-link" data-testid="sleep-story-button"><Moon size={12} /> <span className="story-long">Why I built sleep site</span><span className="story-short">My story</span></button>
    </DialogTrigger>
    <DialogContent className="story-dialog" data-testid="sleep-story-dialog">
      <DialogTitle className="sr-only">Why I built sleep site</DialogTitle>
      <DialogDescription className="story-body" data-testid="sleep-story-text">sleepless patience</DialogDescription>
    </DialogContent>
  </Dialog>
);
